// ---------------------------------------------------------------- All Imports ----------------------------------------------------------------

import axios from 'axios';
import { useEffect, useState } from "react";
import { toast, Toaster } from "react-hot-toast";
import { Link, useLocation } from "react-router-dom";
import addressImage from "../assets/footer/address.svg";
import dotImage from "../assets/footer/dot.svg";
import emailImage from "../assets/footer/email.svg";
import phoneImage from "../assets/footer/phone.svg";
import sendImage from "../assets/footer/tabler_send.svg";

// ---------------------------------------------------------------- All Imports ----------------------------------------------------------------

const Footer = () => {

  const [isLoading, setIsLoading] = useState(false);

  const [formData, setFormData] = useState({
    email: "",
  });

  const path = useLocation()
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" })
  }, [path])

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleSubmit = async (e) => {
    if (e) e.preventDefault();
    const trimmedEmail = formData.email.trim();
    if (!trimmedEmail) {
      toast.error("Please enter your email address.");
      return;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(trimmedEmail)) {
      toast.error("Please enter a valid email address.");
      return;
    }
    if (isLoading) return; // prevent multiple clicks
    setIsLoading(true);

    try {
      const payload = {
        name: "Newsletter Subscriber",
        email: trimmedEmail,
        message: "Newsletter Subscription",
        phone_number: "-",
        country: "-",
      };

      // 1. Send to AWS Backend
      const res = await fetch(
        "https://6aply0b2jk.execute-api.ap-south-1.amazonaws.com/default/paramgroups_contact_us",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );

      if (!res.ok) throw new Error("Network error");

      // 2. Save to Live Excel (Google Sheets)
      try {
        await fetch(
          "https://script.google.com/macros/s/AKfycbzZqwnsEGIpHOuBlYSdzXuJ6hbJ6byBr_1epGiL2nMeOZEFvwlYdvz2OH-ogXby78wsqA/exec",
          {
            method: "POST",
            headers: { "Content-Type": "text/plain;charset=utf-8" },
            body: JSON.stringify(payload),
          }
        );
      } catch (googleErr) {
        console.error("Error saving to Google Sheets:", googleErr);
      }

      // 3. Optional subscribe endpoint sync
      try {
        await axios.post(
          "https://dglk5jazs4.execute-api.eu-north-1.amazonaws.com/default/subscribeus",
          { email: trimmedEmail },
          { headers: { "Content-Type": "application/json" } }
        );
      } catch (subErr) {
        // Ignored if lambda has issues
      }

      toast.success("Subscribed Successfully!");
      setFormData({ email: "" });
    } catch (err) {
      toast.error("Error to Subscribe!");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div className="">
        {/* ------------------------------------------- Section-1 includes hr address email phone  ------------------------------------------- */}
        <div className="flex flex-col xs:flex-row md:flex-row justify-center items-center relative ">
          <div className="w-[90%] 900:w-[80%] h-full md:h-[98%] absolute  div-2-mini z-10"></div>
          <div className="div-1 w-full 1700:w-[36%] 1450:w-[25%] xl:w-[18%]  md:w-[10%] lg:w-[15%]  xs:w-1/5 flex mb-4 md:mb-0">
            <hr className="border-0 h-[3px] md:h-[5px] bg-gradient-to-r from-sky-400 to-cyan-300  w-full  mx-auto md:mx-0 rounded-r" />
          </div>
          <div className="relative z-1 xs:w-[90%] sm:w-full 900:w-4/5 xl:w-[98%] lg:w-[98%] rounded-xl bg-gradient-to-r from-sky-500 via-cyan-300 to-teal-300 p-[3px] md:p-[5px]">
            <div className="bg-black w-full h-full rounded-xl flex flex-col md:flex-row items-center justify-center px-4 900:px-10 py-6 900:py-8 text-white xs:gap-6 900:gap-8 lg:gap-16">
              <div className="flex items-center gap-4 900:gap-6 lg:gap-8 w-full 900:w-[40%] md:w-[37%]">
                <img
                  src={addressImage}
                  className="w-6 h-6 lg:w-8 lg:h-8"
                  alt="Address"
                />
                <div className="address-text flex flex-col gap-1 md:gap-2">
                  <h5 className="text-lg md:text-xl lg:text-2xl xs:text-[18px] font-faustina font-semibold uppercase">
                    Address
                  </h5>
                  <p className="xs:text-base lg:text-sm xl:text-xl font-medium font-faustina ">
                    707 - 710 Everest Onyx, Opp Inox Multiplex, Race Course Rd,
                    Vadodara - 3900 021
                  </p>
                </div>
              </div>
              <div className="email flex items-center gap-4 900:gap-6 lg:gap-8 w-full md:w-[30%]">
                <img
                  src={emailImage}
                  className="w-6 h-6 lg:w-8 lg:h-8"
                  alt="Email"
                />
                <div className="email-text flex flex-col gap-1 md:gap-2">
                  <h5 className="text-lg md:text-xl lg:text-2xl xs:text-[18px] font-faustina font-semibold uppercase">
                    Email
                  </h5>
                  <p className="xs:text-base lg:text-sm xl:text-xl font-medium font-faustina">
                    info@paramgroups.com
                  </p>
                </div>
              </div>
              <div className="phone flex items-center gap-4 900:gap-6 lg:gap-8 w-full md:w-[30%]">
                <img
                  src={phoneImage}
                  className="w-6 h-6 lg:w-8 lg:h-8"
                  alt="Phone"
                />
                <div className="phone-text flex flex-col gap-1 md:gap-2">
                  <h5 className="xs:text-xl lg:text-2xl xs:text-[18px] font-semibold font-faustina uppercase">
                    Phone
                  </h5>
                  <p className="text-sm md:text-base lg:text-base xl:text-xl font-medium font-faustina">
                    +91 701 669 3717
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="w-full 1700:w-[36%] 1450:w-[25%] xl:w-[18%] lg:w-[15%] md:w-[10%] xs:w-1/5 mt-4 md:mt-0">
            <hr className="border-0 h-[3px] md:h-[5px]   bg-gradient-to-r from-teal-300 to-teal-200  w-full mx-auto md:ml-auto rounded-l" />
          </div>
        </div>

        {/* ------------------------------------------- Section-2 includes about us, reference, subscribe ---------------------------------------------------------- */}

        <div className="font-faustina text-white px-4 sm:px-8 lg:px-24 md:px-[50px] ">
          <div className="flex flex-col md:flex-row flex-wrap lg:flex-nowrap justify-between items-start md:py-[100px] sm:py-[60px] xs:py-[40px] gap-16 md:gap-0 lg:gap-12">
            <div className="about-us w-full md:w-1/2 lg:w-1/3 flex flex-col justify-between">
              <div className="about-us-text">
                <p className="md:text-2xl xs:text-[20px] font-semibold">
                  Creating Impact
                  <hr className="w-1/12 mt-2 border-0 h-1 bg-gradient-to-r from-[#1FA2FF] to-[#A6FFCB]" />
                </p>
                <div className="about-us-content flex flex-col font-regular text-LG leading-[30px] gap-4 w-full md:w-[80%] mt-[32px]">
                  <p>
                    Curious about what we’ve achieved over the years? Explore
                    the Param Portfolio to see how our solutions are creating
                    real impact.
                  </p>
                  <Link
                    to="https://portfolio.paramgroups.com/"
                    target="_blank"
                    className="cursor-pointer text-head-gradient text-2xl font-bold transition-all duration-300 hover:text-blue-600 hover:underline"
                  >
                    Portfolio
                    <hr className="w-1/12 mt-2 border-0 h-1 bg-gradient-to-r from-[#1FA2FF] to-[#A6FFCB]" />
                    
                  </Link>
                  
                </div>
              </div>
            </div>

            <div className="right-side w-full md:w-1/2 lg:w-2/3 flex flex-col md:gap-12 lg:flex-row lg:gap-8">
              <div className="reference w-full lg:w-1/2">
                <p className="md:text-2xl xs:text-[20px] font-semibold">
                  Reference Link
                  <hr className="w-1/12 mt-2 border-0 h-1 bg-gradient-to-r from-[#1FA2FF] to-[#A6FFCB]" />
                </p>
                <div className="reference-content flex mt-[32px]">
                  <div className="left text-lg flex flex-col gap-5 leading-9 w-1/2">
                    <p>
                      <Link to={"/aboutus"}>About Us</Link>
                    </p>
                    <p>
                      <Link to={"/our-services"}>Our Ventures</Link>
                    </p>
                    <p>
                      <Link to={"/our-clients"}>Our Clients</Link>
                    </p>
                    <p>
                      <Link to={"/providedServices"}>Our Services</Link>
                    </p>
                  </div>
                  <div className="right leading-9 flex flex-col gap-5 w-1/2 text-lg">
                    <p>
                      <Link to={"/technology"}>Technology</Link>
                    </p>
                    <p>
                      <Link to={"/accreditations-partners"}>
                        Accreditations &amp; Partners
                      </Link>
                    </p>

                    <p>
                      <Link to={"/contact-us"}>Contact Us</Link>
                    </p>
                    <p>
                      <Link to={"/careers"}>Career</Link>
                    </p>

                    <p>
                      <Link to={"/privacy-policy"}>Privacy Policy</Link>
                    </p>
                  </div>
                </div>
              </div>

              <div className="subscribe w-full lg:w-1/2 xs:mt-10 md:mt-0 flex flex-col gap-8">
                <p className="md:text-2xl xs:text-[22px] font-semibold">
                  Subscribe
                  <hr className="w-1/12 mt-2 border-0 h-1 bg-gradient-to-r from-[#1FA2FF] to-[#A6FFCB]" />
                </p>
                <p className="text-lg">
                  Subscribe to our newsletter to get our latest updates
                </p>
                <form
                  onSubmit={handleSubmit}
                  className="email-input flex flex-row text-base"
                >
                  <input
                    type="email"
                    name="email"
                    id="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Your Email Address"
                    disabled={isLoading}
                    className="pl-3 text-[#495057] w-full focus:outline-none focus:ring-0 rounded-s disabled:opacity-75"
                    required
                  />
                  <button
                    type="submit"
                    disabled={isLoading}
                    className="bg-gradient-to-r cursor-pointer from-[#1FA2FF] to-[#A6FFCB] h-full w-[56px] flex justify-center items-center px-4 py-2 relative rounded-e hover:opacity-90 transition-opacity disabled:cursor-not-allowed"
                    title="Subscribe"
                  >
                    {isLoading ? (
                      <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                    ) : (
                      <img
                        src={sendImage}
                        className="w-6 h-6 relative"
                        alt="Send"
                      />
                    )}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>

        {/* ---------------------------------------------------------- Last part Grey footer --------------------------------------------------- */}

        <div className="font-poppins bg-[#3E3E3E] text-white  flex flex-col md:flex-row justify-between items-center h-full px-[8px] sm:px-8 lg:px-[80px] 900:px-[57px] md:px-[20px] py-3">
          <p className="text-xs">
            Copyright © {new Date().getFullYear()} Param Group of Companies. All
            Rights Reserved.
          </p>
          <div className="right w-full md:w-96 underline flex  justify-center items-center gap-4 text-xs mt-2 md:mt-0">
            <a href="http://www.freepik.com/">Images by storyset on Freepik</a>
            <img src={dotImage} alt="" className="w-2 h-2 370:flex xs:hidden" />
            <a href="https://unsplash.com/">Images by unslpash</a>
          </div>
        </div>
      </div>
      <Toaster />
    </>
  );
};

export default Footer;
